export const getAtomicFields = (data) => {
  const documentCalculatedFields = [
    'sub_total',
    'grand_total',
    'total_excluding_tax',
    'total_including_tax',
    'total_payable_amount',
    'total_tax_amount',
    'tax_in_myr',
    'total_item_discount',
    'total_item_charges',
    'header_charges',
    'header_discount',
  ];

  const atomicData = { ...data, item_details: atomicLineItems(data.item_details) };

  documentCalculatedFields.forEach((field) => delete atomicData[field]);

  if (atomicData.charges) {
    atomicData.charges = atomicData.charges.map(({ amount, ...rest }) => rest);
  }
  if (atomicData.discounts) {
    atomicData.discounts = atomicData.discounts.map(({ amount, ...rest }) => rest);
  }
  return atomicData;
};

const atomicLineItems = (items) => {
  const lineItemCalculatedFields = [
    'discount_amount',
    'charge_amount',
    'tax_amount',
    'base_amount',
    'net_amount',
    'total_amount',
  ];

  return items.map(({ id, ...item }) => {
    const atomicItem = { ...item };

    lineItemCalculatedFields.forEach((field) => delete atomicItem[field]);

    if (atomicItem.charges) {
      atomicItem.charges = atomicItem.charges.map(({ amount, ...rest }) => rest);
    }
    if (atomicItem.discounts) {
      atomicItem.discounts = atomicItem.discounts.map(({ amount, ...rest }) => rest);
    }
    if (atomicItem.taxes) {
      atomicItem.taxes = atomicItem.taxes.map(({ amount, ...rest }) => rest);
    }

    if (atomicItem.tax_exemption) {
      const { tax, ...rest } = atomicItem.tax_exemption;
      atomicItem.tax_exemption = rest;
    }
    return atomicItem;
  });
};
